<template>
  <v-row class="align-center justify-center fill-height">
    <v-col class="flex-shrink-1 flex-grow-0">
      <transition name="fade-up" mode="out-in" appear>
        <router-view />
      </transition>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Auth',
  data: () => ({
    
  })
}
</script>